module.exports = __webpack_public_path__ + "img/cox-logo.ac8bd8b.jpg";